export default __webpack_public_path__ + "static/media/partner.efd0a447.png";